module.exports = __webpack_public_path__ + "img/ToyFaces_Colored_BG_40.4bc8004c.jpg";